








































































































































































































































































































































































import { openOttoPay, needsOttoQR, ottoPayAvailable, ottoPayRequest } from '@/utils/ottoPay'
import VueJsonPretty from 'vue-json-pretty'
import { firebaseApp } from '@/firebase'
import { Component, Vue, Watch } from 'vue-property-decorator'
import _, { debounce } from 'lodash-es'
import { mobileBillItemStatus, orderTypeList as orderTypeListALL, orderTypeListRoom, mobileOrderItemStatus } from '@/utils/orderConstant'
import './Order.scss'
import NoDataFound from '@/components/NoDataFound.vue'
import OrderItemCard from '@/components/OrderList/OrderItemCard.vue'
import BillItemCard from '@/components/OrderList/BillItemCard.vue'
import OrderDetail from '@/components/OrderList/OrderDetail.vue'
import DishManagement from '@/components/OrderList/DishManagement.vue'
import BillDetail from '@/components/OrderList/BillDetail.vue'
import ConfirmAtionBox from '@/components/OrderList/ConfirmAtionBox.vue'
import FLoatingButton from '@/components/FloatingButton.vue'
import PosOrderModal from '@/components/PosOrderModal.vue'
import api from '@/api'
import constants from '@/utils/constants'
import { getEdcMidMapping, getRequestId } from '@/utils/helpers'

class OrderReportListItem {
  id: string = ''
  orderId: string = ''
  outletCode: string = ''
  orderType: string = ''
  createdAt: string = ''
  orderStatus: string = ''
  phoneNumber: string = ''
  cancelStatus: string = ''
  totalPoints: string = ''
}

@Component({
  components: {
    VueJsonPretty,
    NoDataFound,
    OrderItemCard,
    OrderDetail,
    BillItemCard,
    BillDetail,
    ConfirmAtionBox,
    FLoatingButton,
    DishManagement,
    PosOrderModal
  },
  filters: {
    handleSelectedOptions(opionsArr) {
      return [
        {
          value: null,
          text: 'Select Outlet Code Order'
        },
        ...opionsArr
      ]
    }
  },
  directives: {
    changeStyle: {
      inserted(el, binding) {
        el.classList.add('changecenter')
        if (
          el.innerHTML === '<p>QR Dine-in</p>' ||
          el.innerHTML === '<p>Dine-in</p>'
        ) {
          el.classList.add('changetwocenter')
        }
      }
    }
  }
})
export default class OrderReportListMobile extends Vue {
  get userType() {
    return this.$store.state.currentUser
      ? this.$store.state.currentUser.Type
      : ''
  }

  isAdmin: boolean = this.userType === 'Admin'
  isRunner: boolean = this.userType === 'Runner'
  $swal: any
  perPage: number = 20
  filterItem = this.filtering
  isInputShow: boolean = false
  isSeachImgShow: boolean = true
  isSectionbModel: boolean = false
  totalOrdersNumber: number = 0
  isOrderBarActive: boolean = true
  isBillBarActive: boolean = false
  isBarShow: boolean = true
  billItemStatus: any = ''
  billOpenCount: number = 0
  billAllCount: number = 0
  orderTypeList: any = this.isRunner ? orderTypeListRoom : orderTypeListALL
  orderTypes = this.orderTypeList
  allParameters: Array<any> = [
    'TRANSFERRED',
    'PREPARED',
    'COMPLETED',
    'READY_PICKUP',
    'ON_DELIVERY',
    constants.UPPER_CANCELLED,
    'PAYMENT_SUCCESS',
    'SUBMITTED',
    'INIT'
  ]
  activeOrderType =
    this.$store.getters.GetActiveOrderType || this.orderTypes[0].type
  orderStatusButtons: Array<any> = []
  activeOrderStatus: string = 'IN_PROGRESS'
  selectedOrder = null // for the selected drop
  inputOrderId = '' // for the input
  selectedStatus = null // for the status button
  newOrderComing: boolean = false
  isOrderDetailShow: boolean = false
  isDishManagementShow: boolean = false
  dishManagementItem: Object = {}
  isBillDetailShow: boolean = false
  isModelShow: boolean = false
  confirmModelTitle: string = ''
  detailOrderId: string = ''
  isConfirmBoxShow: boolean = false
  rejectItem: Object = {}
  nextStatusValue: String = ''
  detailButton: any = ''
  detailButtonShow: boolean = true
  itemOrderStatus: String = ''
  itemOrderId: String = ''
  isPullDown: boolean = false
  detailItem: any
  updateBillStatusPayload: any = {}
  orderStatus: any = mobileOrderItemStatus
  billStatusButtons: any = mobileBillItemStatus
  onClickForRefresh: any = null
  inProgressCount: number = 0
  isPaymentDetailShow: boolean = false
  outletInfo: any = []
  billListFilter: any = {
    uid: '',
    outletCode: '',
    order_type: constants.ALL,
    billing_status: 'IN_PROGRESS',
    filter: ''
  }
  showMoreOutlet: boolean = false
  itemExist: boolean = true
  filterOutletCode: string = ''
  selectedOutlet: any = null
  savedOutlets: any = []
  restaurantItem: {
    id?: string;
    isCheck: boolean;
    text: string;
    type: string;
    value?: string;
    edc_model?: boolean;
  }[] = [
    {
      text: 'ALL',
      type: 'ALL',
      isCheck: false,
      value: ''
    }
  ]
  isGetOutlet: number = 0
  outletCodeName: string = ''
  loadMoreShow: boolean = true
  isLoadMoreOutlet: boolean = false
  onClickOutletLoadMore: any = null
  onFilterOutlet: any = null
  isUpdateOrderStatus: boolean = false
  isCancelOrder: boolean = false
  isRefundOrder: boolean = false
  isNextModalShow: boolean = false
  isChangeBillStatus: boolean = true
  isPosOrderModelShow: boolean = false
  changeStatusBillId: any = ''
  orderItem: any = ''
  paymentMethod: string = 'DEBITCARD'
  currentBillitem: any = {}
  cancelItem: any = {}
  isOverRide: boolean = false
  orderTypeDefaultFilter: string = this.isRunner ? 'ROOM' : ''
  submitLoading: boolean = false
  orderRequestId: string = ''

  get isEDC() {
    return this.$store.state.isEDC
  }

  created() {
    this.onClickForRefresh = debounce(this.refreshData, 300)
    this.onClickOutletLoadMore = debounce(this.loadMoreOutlet, 300)
    this.onFilterOutlet = debounce(this.filterOutlet, 1000)
  }

  async mounted() {
    this.$store.commit('SET_PAGING_PAGE_STORE', 1)
    this.$store.commit('SET_FILTERING_STORE', {})
    sessionStorage.removeItem('cartListInfo')
    sessionStorage.removeItem('timeout')
    sessionStorage.removeItem('showCart')
    sessionStorage.removeItem('qrCode')
    sessionStorage.removeItem('payCallBackInfo')
    sessionStorage.removeItem('orderId')
    let outletCodes = localStorage
      .getItem('outletCodes')!
      .split(',')
      .filter(item => !!item)
    let outletInfo: any = []
    if (localStorage.getItem('selected-outlet')) {
      this.selectedOutlet = JSON.parse(localStorage.getItem('selected-outlet') || '{}')
    }
    if (this.isAdmin || outletCodes.length) {
      let outletList = []
      if (localStorage.getItem('outletList')) {
        outletList = JSON.parse(localStorage.getItem('outletList') || '[]')
      } else {
        await api
          .GetAllStoreForNewPort(
            { page: 1, size: outletCodes.length },
            { byField: '', isDesc: '' },
            {},
            this.userUid
          )
          .then(res => {
            try {
              outletList = res.data.result.data
              localStorage.setItem('outletList', JSON.stringify(outletList))
            } catch (error) {
              throw error
            }
          })
      }
      if (outletList) {
        for (let index = 0; index < outletList.length; index++) {
          const element: any = outletList[index]
          outletInfo.push({
            outletType: element.type,
            value: element.outlet_code,
            text: element.outlet_code + ' - ' + element.name,
            ...element
          })
        }
      }
      if (!this.selectedOutlet && outletInfo.length) {
        localStorage.setItem('selected-outlet', JSON.stringify(outletInfo[0]))
        this.selectedOutlet = outletInfo[0]
      }
      this.outletInfo = outletInfo
    }
    if (!this.userUid) {
      this.logOut()
    } else {
      this.billListFilter.uid = this.userUid
    }
    if (this.selectedOutlet && this.selectedOutlet.id) {
      localStorage.setItem('pos-order-outlet', JSON.stringify(this.selectedOutlet))
      this.outletCodeName = this.selectedOutlet.text
      this.setFilter('outletCode', this.selectedOutlet.value)
      this.billListFilter.outletCode = this.selectedOutlet.value
    } else if (outletInfo.length) {
      localStorage.setItem('pos-order-outlet', JSON.stringify(outletInfo[0]))
    }
    this.setFilter('orderType', this.orderTypes[0].type)
    this.watchOrderTypeSwitch()
    this.watchOrderNumber()
  }

  beforeDestroy() {
    this.resetFilter()
    this.$store.commit('SET_FILTERING_ORDERREPORT', this.filterItem)
  }

  selectPaymentMethod(paymentMethod) {
    this.paymentMethod = paymentMethod
  }

  logOut() {
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.unsetFirebaseToken()
    }
    if (window && typeof (window as any).webkit !== 'undefined') {
      (window as any).webkit.messageHandlers.sendUserInfo.postMessage({
        userID: '',
        isSign: false
      })
    }
    this.$store.dispatch('LOAD_CURRENT_USER', { uid: '' })
    this.$store.dispatch('LOAD_USER_PRIVILEGES', '')
    firebaseApp
      .auth()
      .signOut()
      .then(data => {
        this.$router.push('login')
      })
  }

  showOutlet() {
    this.showMoreOutlet = !this.showMoreOutlet
    this.isInputShow = false
    this.isSeachImgShow = true
    this.isSectionbModel = false
    if (this.isGetOutlet === 0) {
      if (this.isAdmin) {
        this.$store.dispatch('GetAllStore').then(res => {
          res.data.map(v => {
            this.restaurantItem.push({
              text: `${v.outletCode} - ${v.name}`,
              type: `${v.outletCode} - ${v.name}`,
              value: parseInt(v.outletCode),
              outletType: v.type,
              ...v,
              isCheck: this.selectedOutlet && v.id === this.selectedOutlet.id
            })
          })
          if (res.data.length < this.PagingStore.size) {
            this.loadMoreShow = false
          }
          this.itemExist = false
        })
      } else if (!this.isAdmin && this.outletInfo.length !== 0) {
        this.outletInfo.map(v => {
          this.restaurantItem.push({
            text: v.text,
            type: v.text,
            value: v.value,
            outletType: v.type,
            ...v,
            isCheck: this.selectedOutlet && v.id === this.selectedOutlet.id
          })
        })
        this.itemExist = false
        this.loadMoreShow = false
      } else if (!this.isAdmin && this.outletInfo.length === 0) {
        this.restaurantItem = [
          {
            text: 'No restaurant data',
            type: 'No restaurant data',
            isCheck: false,
            value: 'No restaurant data'
          }
        ]
        this.loadMoreShow = false
      }
      this.isGetOutlet = 1
      this.restaurantItem[0].isCheck = !this.selectedOutlet || !this.selectedOutlet.id
    }
  }

  filterOutlet() {
    this.isLoadMoreOutlet = true
    this.restaurantItem = this.filterOutletCode ? [] : [
      {
        text: 'ALL',
        type: 'ALL',
        isCheck: false,
        value: ''
      }
    ]
    this.loadMoreShow = true
    this.$store.commit('SET_PAGING_PAGE_STORE', 0)
    this.$store.commit('SET_FILTERING_STORE', { outletCode: this.filterOutletCode })
    this.loadMoreOutlet()
  }

  loadMoreOutlet() {
    this.isLoadMoreOutlet = true
    this.$store.commit('SET_PAGING_PAGE_STORE', this.PagingStore.page + 1)
    this.$store.dispatch('GetAllStore').then(resp => {
      resp.data.map(v => {
        this.restaurantItem.push({
          text: `${v.outletCode} - ${v.name}`,
          type: `${v.outletCode} - ${v.name}`,
          value: parseInt(v.outletCode),
          outletType: v.type,
          ...v,
          isCheck: this.selectedOutlet && v.id === this.selectedOutlet.id
        })
      })
      if (resp.data.length < this.PagingStore.size) {
        this.loadMoreShow = false
      }
      this.isLoadMoreOutlet = false
    })
  }

  get userUid() {
    return localStorage.getItem('UID')
  }

  get newOrderNumber() {
    return this.$store.getters.GetNewOrderNumber
  }

  // to get page data
  get items(): OrderReportListItem[] {
    return this.$store.getters.GetAllOrderReport
  }

  get orderNumber() {
    return this.$store.getters.GetAllOrderNumber
  }

  get paging() {
    return this.$store.getters.PagingOrderReport
  }

  get GetBillPaging() {
    return this.$store.getters.GetBillPaging
  }

  get filtering() {
    return this.$store.getters.FilteringOrderReport
  }

  get hasNoData() {
    return (
      this.$store.getters.GetHasNoData && this.$store.getters.GetFromFilterView
    )
  }

  // get Loading
  get isLoadingShow() {
    return this.$store.getters.GetIsLoadingShow
  }

  get updateOrderStatus() {
    return this.$store.getters.GetUpdateOrderStatus
  }

  get cancelOrderStatus() {
    return this.$store.getters.CancelOrderStatus
  }

  get progressCount() {
    return this.$store.getters.GetInProgressCount
  }

  get GetNewOrderComing() {
    return this.$store.getters.GetNewOrderComing
  }

  get GetBillList() {
    const result = this.$store.getters.GetBillList
    return result
  }

  get GetBillLodaing() {
    return this.$store.getters.GetBillLodaing
  }

  get billCount() {
    return this.$store.getters.GetBillListCount
  }

  get isNewOrderChangeType() {
    return this.$store.getters.GetIsNewOrder
  }

  get PagingStore() {
    return this.$store.getters.PagingStore
  }

  @Watch('isNewOrder')
  watchNewOrder() {
    if (this.isNewOrderChangeType) {
      this.isOrderBarActive = true
      this.activeOrderStatus = 'IN_PROGRESS'
      this.isBillBarActive = false
      this.handleOrderStatus()
    }
  }

  refreshData() {
    if (this.isOrderBarActive) {
      this.$store.dispatch('GetAllOrderReport')
    }
    if (this.isBillBarActive) {
      this.$store.dispatch('GetAllBillList', this.billListFilter)
    }
  }

  switchOrderType(item) {
    if (this.activeOrderType !== item.type) {
      this.isOrderBarActive = true
      this.isBillBarActive = false
      for (let i in this.orderStatus) {
        this.orderStatus[i].quantity = 0
      }
      this.totalOrdersNumber = 0
      this.inProgressCount = 0
    }
    this.detailButtonShow = true
    this.activeOrderType = item.type
    if (item.type === constants.TOP || item.type === 'ALL' || item.type === constants.ROOM) {
      this.isBarShow = true
    } else {
      this.isBarShow = false
    }
    this.$store.commit(
      'SET_ACTIVE_ORDERTYPE',
      item.type === 'ALL' ? '' : item.type
    )
  }

  handleOnchangeSelectedOrder(item, index) {
    if (item.text === 'ALL') {
      if (this.restaurantItem.length > 1) {
        localStorage.setItem(
          'pos-order-outlet',
          JSON.stringify(this.restaurantItem[1])
        )
        this.$store.commit('UPDATE_EDC_MODEL', this.restaurantItem[1].edc_model)
      }
      localStorage.setItem('selected-outlet', '{}')
    } else {
      localStorage.setItem('pos-order-outlet', JSON.stringify(item))
      localStorage.setItem('selected-outlet', JSON.stringify(item))
      this.$store.commit('UPDATE_EDC_MODEL', item.edc_model)
    }
    this.restaurantItem.map(v => {
      v.isCheck = false
    })
    this.restaurantItem[index].isCheck = true
    this.showMoreOutlet = false
    if (item.text === 'ALL') {
      this.outletCodeName = 'Select Outlet Code Order'
    } else {
      this.outletCodeName = item.text
    }
    this.activeOrderStatus = 'IN_PROGRESS'
    for (let i in this.orderStatus) {
      this.orderStatus[i].quantity = 0
    }
    this.totalOrdersNumber = 0
    this.inProgressCount = 0
    if (this.isOrderBarActive) {
      this.getOrderCountForRestaurant(item.value)
    } else {
      this.getBillCountForRestaurant(item.value)
    }
  }

  getBillCountForRestaurant(value) {
    if (value) {
      this.billListFilter.outletCode = value
      this.setFilter('outletCode', value)
    } else {
      this.billListFilter.outletCode = ''
      this.setFilter('outletCode', '')
    }
    this.$store.dispatch('GetAllBillList', this.billListFilter)
  }

  getOrderCountForRestaurant(value) {
    if (value) {
      this.setFilter('outletCode', value)
      this.billListFilter.outletCode = value
      this.handleOrderStatus()
    } else {
      this.setFilter('outletCode', '')
      this.billListFilter.outletCode = ''
      this.handleOrderStatus()
    }
  }

  handleClickInputOrderId() {
    this.billListFilter.filter = this.inputOrderId
    if (this.isBillBarActive) {
      if (this.GetBillPaging.page === 1) {
        this.$store.dispatch('GetAllBillList', this.billListFilter)
      } else {
        this.$store.commit('SET_BILL_PAGING', 1)
      }
    } else {
      this.setFilter('orderId', this.inputOrderId)
    }
    this.inputOrderId = ''
    this.isInputShow = false
    this.isSeachImgShow = true
    this.isSectionbModel = false
  }

  showSearchInput() {
    this.isInputShow = !this.isInputShow
    this.isSeachImgShow = !this.isSeachImgShow
    this.isSectionbModel = !this.isSectionbModel
  }

  handleClickOrderStatus(item) {
    this.setFilter('orderId', '')
    this.billListFilter.filter = ''
    this.detailButtonShow = true
    if (this.activeOrderStatus === item.value) {
      return
    }
    this.activeOrderStatus = item.value
    if (this.isOrderBarActive) {
      this.setFilter('orderId', '')
      this.detailButtonShow = true
      this.activeOrderStatus = item.value
      this.setFilter('orderStatus', item.status)
    }
    if (this.isBillBarActive) {
      this.$store.commit('SET_BILL_PAGING', 1)
      if (item.value === 'ALL') {
        delete this.billListFilter.billing_status
        this.reload()
      } else {
        this.billListFilter.billing_status = item.value
        this.reload()
      }
    }
  }

  handleNextStatus(status, type) {
    if (this.isOrderBarActive) {
      const currentStatus = this.orderStatus[status]
      if (
        (type === constants.PPTA ||
          type === constants.PPDI ||
          type === constants.TOP ||
          type === constants.OTHERS) &&
        status === 'READY_PICKUP'
      ) {
        return Object.values(this.orderStatus).find(
          (item: any) => item.flowPosition === currentStatus.flowPosition + 2
        )
      } else {
        return Object.values(this.orderStatus).find(
          (item: any) => item.flowPosition === currentStatus.flowPosition + 1
        )
      }
    }
    if (this.isBillBarActive) {
      const currentStatus = this.billStatusButtons[status]
      if (currentStatus.text === 'OPEN') {
        return Object.values(this.billStatusButtons).find(
          (item: any) => item.flowPosition === currentStatus.flowPosition + 1
        )
      } else if (currentStatus.text === 'PAID') {
        return Object.values(this.billStatusButtons).find(
          (item: any) => item.flowPosition === currentStatus.flowPosition + 2
        )
      }
    }
  }

  handClickStatusButton(value, text, orderId, orderItem, title = '') {
    if (text === 'PREPARING') {
      this.orderItem = orderItem
    } else {
      this.orderItem = ''
    }
    this.itemOrderStatus = value
    this.itemOrderId = orderId
    this.isModelShow = !this.isModelShow
    this.confirmModelTitle = title
    this.isConfirmBoxShow = !this.isConfirmBoxShow
    this.isUpdateOrderStatus = true
    this.isCancelOrder = false
    this.nextStatusValue = text
  }

  async confirm() {
    if (this.submitLoading) {
      return
    }
    this.isUpdateOrderStatus = true
    this.isCancelOrder = false
    this.isModelShow = !this.isModelShow
    this.isConfirmBoxShow = !this.isConfirmBoxShow
    const UserName: any = localStorage.getItem('UserName')
    if (this.isOrderBarActive) {
      this.$store
        .dispatch('UpdateOrderStatus', {
          orderId: this.itemOrderId,
          order_status: this.itemOrderStatus
        }).then(res => {
        this.checkInProgressCount('COMPLETED')
      })
    }
    if (this.isBillBarActive) {
      if (this.nextStatusValue === 'PAID') {
        if (ottoPayAvailable && (this.paymentMethod === 'QR' || this.currentBillitem.payment_method === 'QR' || this.currentBillitem.paymentMethod === 'QR')) {
          this.submitLoading = true
          try {
            const outletCode = String(this.currentBillitem.outlet_code || '')
            const ready = await ottoPayRequest('readiness', { outletCode, orderId: this.currentBillitem.billing_calculation.billing_no })
            if (needsOttoQR(this.paymentMethod, ready)) {
              const orderId = this.currentBillitem.billing_calculation.billing_no
              openOttoPay(this, { orderId, totalSales: this.currentBillitem.billing_calculation.total_sales, ottoPay: { provider: 'ottopay-h2h', orderId } })
              return
            }
          } catch (error) { this.$swal(constants.SOMETHING_WROING, error.message, constants.STATUS_ERROR); return } finally { this.submitLoading = false }
        }

        if (this.paymentMethod === 'cash') {
          return this.$store
            .dispatch('UpdateBillStatus', this.updateBillStatusPayload)
            .then(res => {
              if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
                this.$store.dispatch('GetAllBillList', this.billListFilter)
              } else {
                this.$swal(
                  constants.SOMETHING_WROING,
                  res.data.invalidMessage,
                  constants.STATUS_ERROR
                )
              }
            })
        } else {
          if (this.paymentMethod === 'QRPay') {
            this.submitLoading = true
            const MerchantName = localStorage.getItem('UserName')
            const {
              billing_total_amount,
              outlet_code,
              raw_data: {
                user: { name, phoneNo, id: userId }
              }
            } = this.currentBillitem
            // return;
            const orderPayload: any = {
              userId,
              orderType: 'POS',
              orderSource: 'BO',
              TableNo: '',
              promo_value: 0,
              custom_total_payment: Number(billing_total_amount || 0),
              discount_name: '',
              payment: [
                {
                  paymentAmount: Number(billing_total_amount || 0),
                  paymentUsed: 0,
                  paymentMethodCode: this.paymentMethod
                }
              ],
              destinationStore: {
                outletCode: String(outlet_code)
              },
              orderLines: [],
              requestId: this.orderRequestId || (this.orderRequestId = getRequestId()),
              user: {
                qravedUserID: userId,
                name: name || MerchantName,
                phoneNo: phoneNo,
                id: userId
              },
              notes: '',
              contact: {
                phone: phoneNo,
                name: name || MerchantName
              }
            }
            api
              .BoPosOrder(orderPayload)
              .then(res => {
                if (res.data.code !== constants.STATUS_200_STRING) {
                  return this.$swal(
                    constants.SOMETHING_WROING,
                    res.data.message,
                    constants.STATUS_ERROR
                  )
                }
                if (res.data.invalidMessage !== constants.UPPER_SUCCESS) {
                  return this.$swal(
                    constants.SOMETHING_WROING,
                    res.data.invalidMessage,
                    constants.STATUS_ERROR
                  )
                }
                if (openOttoPay(this, res.data.data)) return
                if (window && typeof (window as any).android !== 'undefined') {
                  (window as any).android.payAtCashier(
                    res.data.data.orderId,
                    this.paymentMethod,
                    Number(billing_total_amount || 0),
                    getEdcMidMapping()
                  )
                }
                this.orderRequestId = ''
                this.submitLoading = false
              })
              .catch(err => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  err.response.data.message,
                  constants.STATUS_ERROR
                )
                this.submitLoading = false
                throw err
              })
          }
          if (window && typeof (window as any).android !== 'undefined') {
            (window as any).android.payAtCashier(
              this.currentBillitem.billing_calculation.billing_no,
              this.paymentMethod,
              this.currentBillitem.billing_calculation.total_sales,
              getEdcMidMapping()
            )
          }
        }
        return
      }
      this.$store
        .dispatch('UpdateBillStatus', this.updateBillStatusPayload)
        .then(res => {
          if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
            this.$store.dispatch('GetAllBillList', this.billListFilter)
          } else {
            this.$swal(
              constants.SOMETHING_WROING,
              res.data.invalidMessage,
              constants.STATUS_ERROR
            )
          }
        })
    }
  }

  cancel() {
    this.isModelShow = false
    this.isConfirmBoxShow = false
    this.isUpdateOrderStatus = false
    this.isCancelOrder = true
    this.isRefundOrder = false
  }

  reject(pin = undefined) {
    this.isModelShow = false
    this.isConfirmBoxShow = false
    // cancel order and bill
    if (this.isBillBarActive) {
      this.$store
        .dispatch('UpdateBillStatus', {
          billingNo: this.changeStatusBillId,
          billingStatus: constants.UPPER_CANCELLED,
          pinCode: pin
        })
        .then(res => {
          if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
            this.$store.dispatch('GetAllBillList', this.billListFilter)
          } else {
            this.$swal(
              constants.SOMETHING_WROING,
              res.data.invalidMessage,
              constants.STATUS_ERROR
            )
          }
        })
    } else if (this.cancelItem.paymentMethod === 'CIMB-QR' ||
      this.cancelItem.paymentMethod === 'CIMB-DEBIT' ||
      this.cancelItem.paymentMethod === 'CIMB-CREDIT') {
      let cimbCallbackData = JSON.parse(this.cancelItem.cimbCallbackData)
      const transType = this.cancelItem.paymentMethod === 'CIMB-QR' ? 'QRMPM' : 'SALE'
      console.log(this.rejectItem)
      console.log(transType)
      console.log(cimbCallbackData.traceNo)
      console.log(this.cancelItem.totalSales)
      console.log(cimbCallbackData.referenceId ? cimbCallbackData.referenceId : '')
      if (window && typeof (window as any).android !== 'undefined') {
        (window as any).android.voidCimbPayment(
          this.rejectItem,
          transType,
          cimbCallbackData.traceNo,
          this.cancelItem.totalSales,
          cimbCallbackData.referenceId ? cimbCallbackData.referenceId : ''
        )
      } else {
        this.$swal(
          constants.SOMETHING_WROING,
          'need to void CIMB payment in android',
          constants.STATUS_ERROR
        )
      }
    } else {
      this.$store.dispatch('CancelOrder', { orderId: this.rejectItem, pinCode: pin })
    }
  }

  updateBillStatus(id, status, item) {
    this.currentBillitem = item
    this.changeStatusBillId = id
    this.isBillDetailShow = false
    this.isCancelOrder = false
    this.isOverRide = false
    if (status !== 'OVERRIDE') {
      this.updateBillStatusPayload = {
        billingNo: id,
        billingStatus: status
      }
      this.nextStatusValue = status
      this.isChangeBillStatus = true
      this.isUpdateOrderStatus = true
    } else {
      this.isChangeBillStatus = false
      this.isUpdateOrderStatus = false
      this.isOverRide = true
    }
    this.isConfirmBoxShow = !this.isConfirmBoxShow
    this.isModelShow = true
  }

  showNextModal() {
    this.isNextModalShow = true
    this.isChangeBillStatus = true
  }

  cancelBill() {
    this.isBillDetailShow = false
    this.isNextModalShow = false
    this.isCancelOrder = true
  }

  changeBillStatusPayCashier() {
    const isTop = this.currentBillitem.raw_data.orderType === constants.TOP
    this.isConfirmBoxShow = false
    this.isModelShow = false
    const payload = {
      billingNo: this.changeStatusBillId,
      billingStatus: isTop ? 'PAYING_ON_CASHIER' : 'PAYING_AT_HOTEL'
    }
    this.$store.dispatch('UpdateBillStatus', payload).then(res => {
      if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
        this.$store.dispatch('GetAllBillList', this.billListFilter);
        (window as any).imgLos
          .getInstance()
          .logEvent('CL - Pay at Cashier by BO override', {
            billingNo: this.changeStatusBillId
          })
      } else {
        this.$swal(
          constants.SOMETHING_WROING,
          res.data.invalidMessage,
          constants.STATUS_ERROR
        )
      }
    })
  }

  checkInProgressCount(status) {
    const orderStatus = this.orderTypeList
      .filter(item => item.type === this.activeOrderType)[0]
      .orderStatus.filter(item => item.value === 'ALL')[0].status
  }

  handleClickCancelButton(item) {
    this.isOrderDetailShow = false
    this.isModelShow = true
    this.isConfirmBoxShow = true
    this.rejectItem = item.orderId
    this.isCancelOrder = true
    this.isUpdateOrderStatus = false
    this.cancelItem = item
  }

  handleClickDishManagement(item) {
    this.dishManagementItem = _.cloneDeep(item)
    this.isDishManagementShow = true
  }

  hideDishManagement() {
    this.isDishManagementShow = false
    this.$store.commit('SET_SEARCH_MENU', [])
  }

  showOrderDetail(orderId, orderStatus, type, item) {
    this.itemOrderId = orderId
    this.detailOrderId = orderId
    this.detailItem = item
    this.isModelShow = true
    this.isInputShow = false
    this.isSectionbModel = false
    this.isSeachImgShow = true
    this.detailButtonShow = true
    this.cancelItem = item
    if (this.isOrderBarActive) {
      this.isOrderDetailShow = true
      const currentStatus = this.orderStatus[orderStatus]
      if (currentStatus.buttonShow === true) {
        this.detailButton = this.handleNextStatus(orderStatus, type)
      } else {
        this.detailButtonShow = false
      }
    }
    if (this.isBillBarActive) {
      this.isBillDetailShow = true
      this.billItemStatus = orderStatus
    }
  }

  handleUpdateOrderDetail(payload) {
    this.detailItem = {
      ...this.detailItem,
      ...payload
    }
  }

  hideOrderDetail() {
    this.isOrderDetailShow = false
    this.isBillDetailShow = false
    this.isConfirmBoxShow = false
    this.isModelShow = false
  }

  hideInputSearch() {
    this.isInputShow = false
    this.isSectionbModel = false
    this.isSeachImgShow = true
  }

  clickorderdatail(ButtonValue, ButtonText, item, title = '') {
    if (ButtonValue === 'REJECT') {
      this.isUpdateOrderStatus = false
      this.isCancelOrder = true
      this.rejectItem = item.orderId
    } else {
      this.isUpdateOrderStatus = true
      this.isCancelOrder = false
    }
    this.itemOrderStatus = ButtonValue
    this.isConfirmBoxShow = true
    this.isOrderDetailShow = false
    this.isBillDetailShow = false
    this.confirmModelTitle = title
    this.nextStatusValue = ButtonText
  }

  handleRefundOrder(item) {
    this.orderItem = item
    this.isUpdateOrderStatus = false
    this.isCancelOrder = false
    this.isOrderDetailShow = false
    this.isRefundOrder = true
    this.isModelShow = true
    this.isConfirmBoxShow = true
  }

  refund(amount, reason) {
    this.$store.dispatch('RefundOrder', {
      orderId: this.orderItem.orderId,
      amount: Number(amount),
      reason
    })
    this.isRefundOrder = false
    this.isModelShow = false
    this.isConfirmBoxShow = false
    this.orderItem = ''
  }

  showPosOrder(item) {
    this.orderItem = item
    this.isModelShow = false
    this.isOrderDetailShow = false
    this.isPosOrderModelShow = true
  }

  posOrderPopup(value) {
    this.isPosOrderModelShow = value
  }

  posOrderValue(value) {
    this.reload()
  }

  hideAll() {
    this.isOrderDetailShow = false
    this.isBillDetailShow = false
  }

  selectOrderList() {
    this.billListFilter.filter = ''
    this.isOrderBarActive = true
    this.isBillBarActive = false
    this.watchOrderTypeSwitch()
    this.handleOrderStatus()
    this.$store.dispatch('GetAllOrderReport')
  }

  selectBillList() {
    this.billListFilter.filter = ''
    this.isBillBarActive = true
    this.isOrderBarActive = false
    this.activeOrderStatus = 'IN_PROGRESS'
    this.billListFilter.billing_status = 'IN_PROGRESS'
    this.$store.commit('SET_IS_NEW_ORDER', false)
    this.reload()
    this.handleBillStatus()
  }

  @Watch('billCount')
  watchBillCount() {
    if (this.billCount.length) {
      for (let i in this.billStatusButtons) {
        this.billStatusButtons[i].quantity = 0
      }
      this.billAllCount = 0
      let allCount: number = 0
      let hiddCount: number = 0
      this.billCount.map(v => {
        if (v.billing_status_cond !== 'IN_PROGRESS') {
          allCount += Number(v.count)
        }
        if (v.billing_status_cond === 'Issue') {
          hiddCount = v.count
        } else {
          this.billStatusButtons[v.billing_status_cond].quantity = v.count
        }
      })
      this.billAllCount = allCount - hiddCount
      this.billStatusButtons['ALL'].quantity = this.billAllCount
      if (this.activeOrderStatus === 'PAYING_ON_CASHIER') {
        this.$store.commit(
          'SET_BILL_TOTAL',
          this.billStatusButtons['REQUESTING CASHIER PAYMENT'].quantity
        )
      } else if (this.activeOrderStatus === 'IN_PROGRESS') {
        this.$store.commit(
          'SET_BILL_TOTAL',
          this.billStatusButtons['IN PROGRESS'].quantity
        )
      } else if (this.activeOrderStatus === 'PAYING_AT_HOTEL') {
        this.$store.commit(
          'SET_BILL_TOTAL',
          this.billStatusButtons['PAYING AT HOTEL'].quantity
        )
      } else {
        this.$store.commit(
          'SET_BILL_TOTAL',
          this.billStatusButtons[this.activeOrderStatus].quantity
        )
      }
    } else {
      this.billAllCount = 0
      this.billOpenCount = 0
      for (let i in this.billStatusButtons) {
        this.billStatusButtons[i].quantity = 0
      }
    }
  }

  @Watch('GetNewOrderComing')
  watchNewOrderComing(newValue, oldValue) {
    if (newValue > oldValue) {
      this.handleOrderStatus()
    }
  }

  @Watch('isOrderDetailShow')
  @Watch('isBillDetailShow')
  @Watch('isDishManagementShow')
  watchDishManagement() {
    if (
      this.isDishManagementShow ||
      this.isOrderDetailShow ||
      this.isBillDetailShow
    ) {
      document.getElementsByTagName('body')[0].className = 'noScroll'
    } else {
      document.body.classList.remove('noScroll')
    }
  }

  @Watch('isModelShow')
  watchModelShow() {
    if (this.isModelShow) {
      document.getElementsByTagName('body')[0].className = 'noScroll'
    } else {
      this.isCancelOrder = false
      this.isUpdateOrderStatus = false
      this.isNextModalShow = false
      this.isUpdateOrderStatus = false
      this.isChangeBillStatus = true
      document.body.classList.remove('noScroll')
    }
  }

  @Watch('$store.getters.GetActiveOrderType')
  watchActiveOrderType(newval) {
    this.activeOrderType = newval || 'ALL'
  }

  @Watch('activeOrderType')
  watchOrderTypeSwitch() {
    if (this.isOrderBarActive) {
      this.activeOrderStatus = 'IN_PROGRESS'
      this.handleOrderStatus()
    }
    if (this.isBillBarActive) {
      this.handleBillStatus()
    }
  }

  @Watch('filterItem', { deep: true })
  watchFilterItem() {
    if (this.isOrderBarActive) {
      if (this.paging.page === 1) {
        this.doSearch(true)
      } else {
        this.$store.commit('SET_PAGING_PAGE_ORDERREPORT', 1)
      }
    }
  }

  @Watch('updateOrderStatus.isSuccess')
  watchOrderStatusSuccess() {
    if (this.updateOrderStatus.isSuccess) {
      this.doSearch(true)
    }
  }

  @Watch('updateOrderStatus.error')
  watchOrderStatusError() {
    if (this.updateOrderStatus.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderStatus.error,
        constants.STATUS_ERROR
      )
    }
  }

  @Watch('cancelOrderStatus.isSuccess')
  watchCancleOrderStatus() {
    if (this.cancelOrderStatus.isSuccess) {
      this.doSearch(true)
    }
  }

  @Watch('cancelOrderStatus.error')
  watchOrderCancelError() {
    if (this.cancelOrderStatus.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.cancelOrderStatus.error,
        constants.STATUS_ERROR
      )
    }
  }

  @Watch('newOrderNumber')
  showAlertMessage(newValue, oldValue) {
    if (oldValue !== undefined) {
      this.newOrderComing = true
    }
  }

  @Watch('orderNumber')
  watchOrderNumber() {
    for (let i = 0; i < this.orderStatusButtons.length; i++) {
      const element = this.orderStatusButtons[i]
      let quantity = 0
      for (let j = 0; j < element.status.length; j++) {
        const item = element.status[j]
        for (let k = 0; k < this.orderNumber.length; k++) {
          const count = this.orderNumber[k]
          if (item === count.order_status) {
            quantity += count.count
          }
        }
      }
      element.quantity = quantity
    }
  }

  doSearch(fromFilter: boolean = false) {
    this.newOrderComing = false
    this.$store.commit('SET_FILTERING_ORDERREPORT', this.filterItem)
    this.reload(1, fromFilter)
  }

  setFilter(key, value) {
    this.filterItem[key] = value
  }

  resetFilter() {
    this.filterItem = {
      orderId: '',
      outletCode: '',
      orderType: '',
      orderStatus: [],
      createdAt: {
        startDate: '',
        endDate: ''
      },
      phoneNumber: '',
      cancelStatus: []
    }
  }

  reload(page: any = 1, fromFilter: boolean = false) {
    if (this.isBillBarActive) {
      if (page) {
        this.$store.commit('SET_BILL_PAGING', page)
      }
      this.$store.dispatch('GetAllBillList', this.billListFilter)
    }
    if (this.isOrderBarActive) {
      if (page) {
        this.$store.commit('SET_PAGING_PAGE_ORDERREPORT', page)
      }
      this.$store.dispatch('GetAllOrderReport', { fromFilter })
    }
  }

  setPerPage() {
    if (this.isBillBarActive) {
      this.$store.state.billListOrder.pagingBillReport.page = 1
      this.$store.state.billListOrder.pagingBillReport.size = this.perPage
      this.$store.dispatch('GetAllBillList', this.billListFilter)
    }
    if (this.isOrderBarActive) {
      this.$store.state.orderReport.pagingOrderReport.page = 1
      this.$store.state.orderReport.pagingOrderReport.size = this.perPage
      this.$store.dispatch('GetAllOrderReport')
    }
  }

  limitPaging(page, total) {
    if (page < 6) {
      return 7
    }
    if (page > Math.ceil(total / this.perPage) - 5) {
      return 7
    }
    return 5
  }

  handleBillStatus() {
    if (this.activeOrderType === 'ALL') {
      const tableBillStatus = Object.values(this.billStatusButtons).filter(
        (item: any) => item.tableOrder || item.roomService
      )
      this.orderStatusButtons = tableBillStatus
    } else if (this.activeOrderType === constants.TOP) {
      const tableBillStatus = Object.values(this.billStatusButtons).filter(
        (item: any) => item.tableOrder
      )
      this.orderStatusButtons = tableBillStatus
    } else if (this.activeOrderType === constants.ROOM) {
      const tableBillStatus = Object.values(this.billStatusButtons).filter(
        (item: any) => item.roomService
      )
      this.orderStatusButtons = tableBillStatus
    }
  }

  handleOrderStatus() {
    this.setFilter('orderId', '')
    this.setFilter(
      'orderStatus',
      this.orderTypeList.filter(item => item.type === this.activeOrderType)[0]
        .orderStatus[0].status
    )
    this.orderStatusButtons = this.orderTypeList.filter(
      item => item.type === this.activeOrderType
    )[0].orderStatus
    this.billListFilter.order_type = this.activeOrderType
    this.setFilter(
      'orderType',
      this.activeOrderType === 'ALL'
        ? this.orderTypeDefaultFilter
        : this.activeOrderType
    )
  }

  checkOrderStatusHandle = (item, paymentMethod, event) => {
    if (event) {
      event.stopPropagation
        ? event.stopPropagation()
        : (event.cancelBubble = true)
    }
    api.GetPosOrderStatus({ orderId: item.orderId }, paymentMethod).then(res => {
      const status = res.data.data.status
      if (status !== 'INIT') {
        this.$store.dispatch('GetAllOrderReport')
      }
    }).catch(err => {
      throw err
    })
  }
}
